import { appNavigation } from "../../styles/appNavigation";
import IconHelper from "./IconHelper";

const ReportsIcon = (props) => (
  <IconHelper {...props} defaultWidth={24} defaultHeight={24}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.0498"
        y="3.76343"
        width="3.72254"
        height="10.0631"
        rx="0.327257"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1"
      />
      <rect
        x="7.77246"
        y="0.327148"
        width="3.72254"
        height="13.4993"
        rx="0.327257"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1"
      />
      <rect
        x="0.327148"
        y="7.60864"
        width="3.72254"
        height="6.21787"
        rx="0.327257"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1"
      />
    </svg>
  </IconHelper>
);

export default ReportsIcon;
